<div class="rx-intuitive-tooth-treatment-viewlist-item">
	<div class="rx-intuitive-tooth-treatment-viewlist-item__leading-container">
		<div class="rx-intuitive-tooth-treatment-viewlist-item__title-and-badge">
			<rx-intuitive-indication-badge
				*ngIf="isIndicationVisible"
				class="rx-intuitive-tooth-treatment-viewlist-item__badge"
				[indication]="indicationId"
			/>
			<ng-content select="[rxIntuitiveViewlistItemTitle]" />
		</div>
		<div class="rx-intuitive-tooth-treatment-viewlist-item__preview" [attr.title]="previewTitle || null">
			<ng-content select="[rxIntuitiveViewlistItemPreview]" />
		</div>
	</div>
	<div class="rx-intuitive-tooth-treatment-viewlist-item__trailing-container">
		<tlk-chevron-right-icon class="rx-intuitive-tooth-treatment-viewlist-item__chevron-icon" />
	</div>
</div>
